import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronRight } from "@air/next-icons";
import { ComboboxOptionText } from "@reach/combobox";
import BoardThumbnail from "~/components/BoardThumbnail/BoardThumbnail";
import { BoardSuggestionBreadcrumbs } from "~/components/SearchBar/Suggestion/BoardSuggestionBreadcrumbs";
import { SearchSuggestionContainer } from "~/components/SearchBar/Suggestion/SearchSuggestionContainer";
export const BOARD_UNIQ_CHAR = "\0";
export const BOARD_UNIQ_CHAR_REGEXP = new RegExp(BOARD_UNIQ_CHAR, "g");
export const BoardSuggestion = (param)=>{
    let { board, onClick, index } = param;
    var _board_ancestors;
    // Combobox does not allow by default for duplicated options
    // If there are any options with the same value, both are highlighted when user navigates using arrow up/down
    // But we can have two boards with the same title. And there is no option from Combobox to recognize between board and search
    // For Combobox, option is always text (value)
    // So, this is a nasty hack to avoid such confusion. We add NULL (U+0000) char to each board and repeat it 'index' times
    // This way we do not display anything additional in search/suggestions, but for Combobox, values are different
    const uniqBoardTitle = "".concat(board.title).concat(BOARD_UNIQ_CHAR.repeat(index));
    var _board_ancestors1;
    return /*#__PURE__*/ _jsxs(SearchSuggestionContainer, {
        index: index,
        value: uniqBoardTitle,
        onClick: ()=>onClick(board),
        "data-board-id": board.id,
        children: [
            /*#__PURE__*/ _jsx(BoardThumbnail, {
                board: board,
                sizes: "40px",
                width: 40,
                height: 40
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "ml-3 flex flex-1 flex-col justify-center",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "truncate",
                        children: /*#__PURE__*/ _jsx(ComboboxOptionText, {})
                    }),
                    !!((_board_ancestors = board.ancestors) === null || _board_ancestors === void 0 ? void 0 : _board_ancestors.length) ? /*#__PURE__*/ _jsx(BoardSuggestionBreadcrumbs, {
                        ancestors: (_board_ancestors1 = board.ancestors) !== null && _board_ancestors1 !== void 0 ? _board_ancestors1 : []
                    }) : null
                ]
            }),
            /*#__PURE__*/ _jsx(ChevronRight, {
                className: "size-6 text-grey-10"
            })
        ]
    });
};
